import { LoginViewComponent } from './../../login/login-view/login-view.component';
import { Component, OnInit, Input, ViewChild, EventEmitter, Output, OnDestroy, HostListener, ElementRef } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { Router } from '@angular/router';
import { SharedContainer } from '../../../shared.container';
import { DashboardService } from '../../../../core/services/dashboard.service';
import { Angulartics2 } from 'angulartics2';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    selector: 'app-right-navigation',
    templateUrl: 'right-nav.component.html',
    styleUrls: ['right-nav.component.css', 'right-nav.component.scss']
})

export class RightNavigationComponent implements OnInit {

    @Input() userlogged: boolean;
    @Input() userInfo;
    @Input() isHome;
    @Input() isResults;
    @Input() isBooking;
    @Input() headerType;
    @Input() unreadMessages;
    @Input() activeOffers;
    @Output() openLoginModal: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('loginModal') loginModal: LoginViewComponent;

    @Output()
    logout: EventEmitter<any> = new EventEmitter();

    mobileMenuOpen = false;
    showViewOffers: Boolean = false;
    isLoggedIn: boolean;
    offerCount: Number = 0;
    requestCount: Number = 0;
    timer: any;
    inSearch: Boolean = false;
    showNewRequestBtnHeader: Boolean = false;

    dashMenuOpen: Boolean = false;
    accountMenuOpen: Boolean = false;

    defaultAvatar = '../../../../../assets/img/user-avatar_gray-2.svg';

    deviceType: DeviceDetectorService;

    constructor(protected router: Router, private locationStrategy: LocationStrategy, private deviceInfo: DeviceDetectorService,
        private sharedContainer: SharedContainer, private dashboardService: DashboardService, private angulartics2: Angulartics2,
        private eRef: ElementRef) { }


    @HostListener('document:click', ['$event'])
    clickout(event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            if (this.dashMenuOpen || this.accountMenuOpen) {
                this.dashMenuOpen = false;
                this.accountMenuOpen = false;
            }
        }
    }

    ngOnInit() {
        this.deviceType = this.deviceInfo;
        this.router.events.subscribe(val => {
            const path = this.locationStrategy.path();
            if (this.dashMenuOpen || this.accountMenuOpen) {
                this.dashMenuOpen = false;
                this.accountMenuOpen = false;
            }
            if (path.includes('/search') || path.includes('login-page')) {
                this.inSearch = true;
            } else {
                this.inSearch = false;
            }
            if (path.includes('/results') || path.includes('property')) {
                this.showNewRequestBtnHeader = true;
            } else {
                this.showNewRequestBtnHeader = false;
            }
            if (path.includes('/results') || path.includes('/search') || path.includes('/')) {
                this.showViewOffers = true;
            } else {
                this.showViewOffers = false;
            }
            if (this.mobileMenuOpen) {
                this.mobileMenuOpen = false;
                const profile = <HTMLElement>document.getElementById('profileSelected');
                profile.classList.remove('profileSelected');
            }
        });
        const interval = setInterval(() => {
            const user = localStorage.getItem('user');
            if (user) {
                this.isLoggedIn = true;
                clearInterval(interval);
            }
        }, 1000);
        this.isLoggedIn = this.sharedContainer.isLoggedIn$;
        if (this.isLoggedIn) {
            this.dashboardService.getAllActiveOffersByUser(this.sharedContainer.getUserId()).subscribe(data => {
                this.offerCount = data;
                this.activeOffers = data;
            });
            this.dashboardService.getAllActiveRequestsByUser(this.sharedContainer.getUserId()).subscribe(data => {
                this.requestCount = data.length;
            });
            this.timer = setInterval(() => {
                this.dashboardService.getAllActiveOffersByUser(this.sharedContainer.getUserId()).subscribe(data => {
                    this.offerCount = data;
                    this.activeOffers = data;
                });
                this.dashboardService.getAllActiveRequestsByUser(this.sharedContainer.getUserId()).subscribe(data => {
                    this.requestCount = data.length;
                });
            }, 5000);
        } else {
            setTimeout(() => {
                this.isLoggedIn = this.sharedContainer.isLoggedIn$;
                if (this.isLoggedIn) {
                    this.dashboardService.getAllActiveOffersByUser(this.sharedContainer.getUserId()).subscribe(data => {
                        this.offerCount = data;
                        this.activeOffers = data;
                    });
                    this.dashboardService.getAllActiveRequestsByUser(this.sharedContainer.getUserId()).subscribe(data => {
                        this.requestCount = data.length;
                    });
                    this.timer = setInterval(() => {
                        this.dashboardService.getAllActiveOffersByUser(this.sharedContainer.getUserId()).subscribe(data => {
                            this.offerCount = data;
                            this.activeOffers = data;
                        });
                        this.dashboardService.getAllActiveRequestsByUser(this.sharedContainer.getUserId()).subscribe(data => {
                            this.requestCount = data.length;
                        });
                    }, 10000);
                } else {
                    const timer = setInterval(() => {
                        this.isLoggedIn = this.sharedContainer.isLoggedIn$;
                        if (this.isLoggedIn) {
                            this.dashboardService.getAllActiveOffersByUser(this.sharedContainer.getUserId()).subscribe(data => {
                                this.offerCount = data;
                                this.activeOffers = data;
                            });
                            this.dashboardService.getAllActiveRequestsByUser(this.sharedContainer.getUserId()).subscribe(data => {
                                this.requestCount = data.length;
                            });
                            this.timer = setInterval(() => {
                                this.dashboardService.getAllActiveOffersByUser(this.sharedContainer.getUserId()).subscribe(data => {
                                    this.offerCount = data;
                                    this.activeOffers = data;
                                });
                                this.dashboardService.getAllActiveRequestsByUser(this.sharedContainer.getUserId()).subscribe(data => {
                                    this.requestCount = data.length;
                                });
                            }, 5000);
                        }
                    }, 2000);
                }
            }, 5000);
        }
    }

    checkUser() {
        if (localStorage.getItem('currentUser')) {
            alert('YES OF COURSE');
        } else {
            alert('NO, SORRY!');
        }
    }

    viewOffers() {
        this.router.navigate(['my-dashboard/my-requests']);
    }

    logoutUserMobile() {
        this.logout.emit();
    }

    logoutUser() {
        this.logout.emit();
    }

    reloadPage() {
        window.location.reload(); // tslint:disable-line:deprecation
    }

    openModal(data) {
        console.log('opening modal...', data);
        this.openLoginModal.emit(data);
    }

    toggleMobileMenu() {
        this.mobileMenuOpen = !this.mobileMenuOpen;
        const profile = <HTMLElement>document.getElementById('profileSelected');
        if (this.mobileMenuOpen) {
            profile.classList.add('profileSelected');
        } else {
            profile.classList.remove('profileSelected');
        }
    }

    isMobile() {
        const w = window.innerWidth;
        if (w < 992) {
            return true;
        }
        return false;
    }

    simpleFunction() {
        console.log('Hi');
    }

    goToLoginPage(intent: string) {
        this.angulartics2.eventTrack.next({ action: 'LoginPageHeader' });
        this.router.navigate(['login-page'], { queryParams: { intent: intent } });
    }

    goToPropertyReg() {
        this.angulartics2.eventTrack.next({ action: 'PropertyRegistrationHeader' });
        this.router.navigate(['application-form/en']);
    }

    angulartics2Track(action: string) {
        this.angulartics2.eventTrack.next({ action: action });
    }

    goToNewSearch() {
        this.router.navigate(['/search']);
    }

}
